import { styled } from '@mui/material/styles'
import { border, xxllncColor } from '../../layout/themes'
import { FC, ReactElement } from 'react'

export const EmptyContainer: FC<ContainerProps> = ({ children }) => (
  <Root className={classes.root}>
    {children}
  </Root>
)

interface ContainerProps {
  children: ReactElement
}

const PREFIX = 'xxllncEmptyContainer'

const classes = {
  root: `${PREFIX}-root`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: xxllncColor.light100,
    borderRadius: border.radius.md,
    width: '100%',
  },
}))
